import React, { Component } from 'react';
import withGoBack from '../../common/withGoBack';
import { onGoBack } from '../../common/globals';

class TypeChangeConfirmationModal extends Component {
  _onNotChange = () => {
    const { goBack, editManageCase, onCancelTypeChange } = this.props;
    if (editManageCase) {
      onGoBack(goBack);
    } else {
      onCancelTypeChange();
    }
  }

  render() {
    const { onSaveChanges, caseRes } = this.props;
    let selectedSetsCount = 0;
    if (Object.keys(caseRes).length > 0) {
      caseRes.case_sets.map((value) => {
        selectedSetsCount += Number(value.Quantity);
      });
    }
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="typeChangeConfirmationModal"
        tabIndex="-1"
        aria-labelledby="typeChangeConfirmationModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="typeChangeConfirmationModal">OPtimize</h5>
              <p>{`If you change the Case Type, the ${selectedSetsCount} sets selected for this case will be removed.
                Are you sure?`}
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link btn-left w-100"
                    data-bs-dismiss="modal"
                    onClick={this._onNotChange}
                  >No
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link w-100"
                    onClick={() => onSaveChanges()}
                    data-bs-dismiss="modal"
                  >Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withGoBack(TypeChangeConfirmationModal);
